import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';

import CircledRadioButton from './CircledRadioButton';

export const Wrapper = styled.div`
  position: relative;
  margin-top: 30rem;

  display: flex;
`;

const RadioButtons = ({ amount, currentActive, onRadioClick }: {
  amount: number,
  currentActive: number,
  onRadioClick: (i: number) => void
}) => {
  const [range, setRange] = useState<boolean[]>([]);

  useEffect(() => {
    const array: boolean[] = [];
    array.length = amount;
    array.fill(false);

    setRange(array);
  }, [amount]);

  return (
    <Wrapper>
      {range.map((_, i) =>
        <CircledRadioButton
          key={i}
          index={i}
          active={i === currentActive}
          onRadioClick={onRadioClick}
        />
      )}
    </Wrapper>
  );
}

export default RadioButtons;